import FormInput from '../templates/FormInput';
import { FormItemProps } from '../templates/FormProps';
import { MESSAGE } from '@vindr/services/constants/message.constant';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const Email = ({
  name = 'email',
  label = 'Email',
  placeholder = 'Enter Email',
  rules,
  required = false,
  disabled,
  ...props
}: FormItemProps) => {
  const { t } = useTranslation('Vindoc');

  const rulesMemo = useMemo(() => {
    const rulesState: any = [
      { type: 'email', message: `${t('Enter in the format')}: name@example.com` },
    ];

    if (required) rulesState.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
    if (rules) rulesState.push(...rules);

    return rulesState;
  }, [t, required, rules]);

  return <FormInput rules={rulesMemo} {...{ name, label, placeholder, disabled, ...props }} />;
};

export default Email;
